module.exports = __webpack_public_path__ + "img/3e42f88262a5b037bd5ce1a0bcb0a42.3f6df043.png";